module.exports = __webpack_public_path__ + "static/img/music_quiz_photo.245401a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/music_quiz/music_quiz_photo.png
// module id = zulH
// module chunks = 1